export const APP_STORE_APPLE_URL =
  process.env.EXPO_PUBLIC_APP_STORE_APPLE_URL ||
  'https://apps.apple.com/us/app/communiful/id6736870572';
export const APP_STORE_GOOGLE_URL =
  process.env.EXPO_PUBLIC_APP_STORE_GOOGLE_URL ||
  'https://play.google.com/store/apps/details?id=rsvp.sunrise.app&pli=1';
